import { render, staticRenderFns } from "./attributeprofile.vue?vue&type=template&id=493f56cc"
import script from "./attributeprofile.vue?vue&type=script&lang=js"
export * from "./attributeprofile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports